// Цаашид энэ файлыг өөрчилснөөр системийн хэмжээнд эрхүүд автоматаар шинэчлэгдэнэ
export const ROLE_PERMISSIONS = {
  // Мэдэгдэлтэй холбоотой эрх бүхий хэрэглэгчид 
  NOTIFICATION_PRIVILEGED_USERS: [
    "Админ",
    "Терминалын газрын захирал",
    "Товарын хэлтсийн дарга",
    "Кассир",
    "Терминалын хэлтсийн дарга",
    "Тээврийн газрын захирал",
    "Тээврийн хэлтсийн дарга",
  ]
};

export const hasPermission = (userRole, permissionGroup) => {
  return ROLE_PERMISSIONS[permissionGroup]?.includes(userRole) || false;
};
